import packageInfo from '../../package.json';
import Environments from './environments.d';

export const environments: Environments = {
  production: false,
  version: `${packageInfo.version}.test`,
  contactMail: 'sharewave@hub83.cloud',
  supportMail: 'sharewave@hub83.cloud',
  appUrls: {
    frontend: 'https://sharewave.hub83.cloud/',
    backend: 'https://sharewave-api.hub83.cloud/api',
    landing: 'https://sharewave.io',
    developer: 'https://contentmedia.pe/'
  },
  localStorageKeys: {
    token: 'SHAREWAVE_TOKEN',
    userData: 'SHAREWAVE_USERDATA'
  }
}
